import { UserGuard } from './user.guard';
import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router
} from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

import { Role } from "./user.model";

@Injectable({
  providedIn: "root"
})
export class TravelAdvisorGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    return UserGuard.canActivateWithRole(this.router, state, this.auth.user$, Role.TRAVEL_ADVISOR);
  }
}
